import { useScrollAnimation, useParallax } from '@/hooks/useScrollAnimation';

export default function EmergencyCTA() {
  const { ref, isVisible } = useScrollAnimation();
  const bg = useParallax(0.2);

  return (
    <section className="px-4 md:px-8 lg:px-12 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div ref={ref} className={`relative rounded-[2.5rem] overflow-hidden reveal-scale ${isVisible ? 'is-in' : ''}`}>
          {/* Parallax background */}
          <div className="absolute inset-0 overflow-hidden">
            <div
              ref={bg.ref}
              className="absolute inset-x-0 -top-16 -bottom-16"
              style={{ transform: `translateY(${bg.offset}px)` }}
            >
              <img
                src="https://static.readdy.ai/image/5774bb29582c40f5252e7d37d3c89ae3/796f6aa30fdfbf512ac61fb077a00eb3.png"
                alt="Fachada Clínica Tarija Vitalmedic SRL"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/95 via-secondary-950/80 to-secondary-950/50" />
            <div className="absolute inset-0 texture-dots-light opacity-20" />
          </div>

          <div className="relative px-7 md:px-16 py-16 md:py-24">
            <div className="max-w-xl">
              <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-bold uppercase tracking-[0.15em] mb-6">
                <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse" />
                Emergencias
              </span>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-medium text-background-50 mb-5 leading-[1.08]">
                Atención de urgencias las <span className="italic text-accent-500">24 horas</span>
              </h2>
              <p className="text-background-200 text-base md:text-lg mb-9 leading-relaxed">
                Nuestro servicio de emergencias está disponible todo el día, todos los días. Si necesitas atención inmediata, contáctanos ahora.
              </p>
              <div className="flex flex-col sm:flex-row items-start gap-3 sm:gap-4">
                <a
                  href="tel:+59177173439"
                  className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-line" />
                  </span>
                  Llamar al 77173439
                </a>
                <a
                  href="https://wa.me/59177173439"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-background-50/10 border border-background-50/30 text-background-50 text-sm font-semibold hover:bg-background-50/20 transition-all whitespace-nowrap cursor-pointer"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-whatsapp-line" />
                  </span>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}